import clsx from "clsx";

import { MainVisualSkeleton } from "../../../main-visual/main-visual";

/**
 * 拠点一覧取得中のスケルトン。SiteCard 実レイアウトと同じ骨格・寸法で描画する。
 * 価格は取得後に各行で個別スケルトン（PriceSkeleton）に切り替わる。
 */
export function SiteListSkeleton() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="部屋タイプを読み込み中"
      className="flex flex-col gap-[40px]"
    >
      {Array.from({ length: 3 }).map((_, i) => (
        <SiteCardSkeleton key={i} />
      ))}
    </div>
  );
}

/** 単色ブロック。PriceSkeleton と同じ surface-subtle + pulse */
function Block({ className }: { className?: string }) {
  return (
    <div
      className={clsx(
        "bg-dx-surface-subtle animate-pulse rounded-sm",
        className,
      )}
      aria-hidden
    />
  );
}

/** SiteCard と同じ骨格（ヘッダ行 + 写真/グループ 2 カラム） */
function SiteCardSkeleton() {
  return (
    <div className="flex flex-col gap-[16px] pt-[16px] lg:gap-[24px] lg:pt-0">
      {/* ヘッダ: 拠点名 + 住所（左）、fromPrice（右） */}
      <div className="flex items-center gap-[4px] px-[16px] lg:px-0">
        <div className="flex min-w-px flex-1 flex-col gap-[4px]">
          <Block className="h-[24px] w-[160px]" />
          <Block className="h-[12px] w-[220px] max-w-[60%]" />
        </div>
        <Block className="h-[24px] w-[120px] shrink-0" />
      </div>

      {/* 写真ギャラリー + 建築タイプグループ */}
      <div className="flex flex-col gap-0 lg:flex-row lg:gap-[24px]">
        <div className="lg:max-w-[400px] lg:min-w-0 lg:flex-1">
          <MainVisualSkeleton showThumbnails={false} />
        </div>
        <div className="flex min-w-px flex-1 flex-col gap-0 lg:min-w-[290px] lg:gap-[24px]">
          <ArchitectureGroupSkeleton />
          <ArchitectureGroupSkeleton />
        </div>
      </div>
    </div>
  );
}

/** ArchitectureTypeGroup（常時展開）と同じ骨格（名前 + 人数行 + 部屋行 1 件分） */
function ArchitectureGroupSkeleton() {
  return (
    <div className="border-dx-border-default flex flex-col gap-[8px] border-t py-[16px] lg:border">
      <div className="flex flex-col gap-[8px] px-[16px]">
        <Block className="h-[28px] w-[140px]" />
        <Block className="h-[24px] w-[80px]" />
      </div>
      <div className="flex items-start gap-[16px] px-[16px] pt-[8px]">
        <div className="flex min-w-px flex-1 flex-col gap-[8px]">
          <Block className="h-[24px] w-[160px]" />
          <Block className="h-[24px] w-[100px]" />
        </div>
        <Block className="h-[32px] w-[96px] shrink-0 rounded-full" />
      </div>
    </div>
  );
}
